// Pure helpers for the sidebar's Recent tab.
//
// No DOM, no React, no time-zone configuration — relies on the host's
// local time via Date. Tests pass a deterministic `now` so this stays
// reproducible across machines.

export function parentPathOf(path) {
  const i = path.lastIndexOf('/');
  return i < 0 ? '' : path.slice(0, i);
}

const MINUTE = 60 * 1000;
const HOUR   = 60 * MINUTE;
const DAY    = 24 * HOUR;

function startOfLocalDay(ts) {
  const d = new Date(ts);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatRelativeTime(mtime, now) {
  if (mtime == null) return '';
  const delta = now - mtime;
  if (delta < MINUTE) return 'just now';
  if (delta < HOUR) {
    const mins = Math.floor(delta / MINUTE);
    return `${mins} min ago`;
  }
  const todayStart = startOfLocalDay(now);
  if (mtime >= todayStart) {
    const d = new Date(mtime);
    const h = d.getHours();
    const m = String(d.getMinutes()).padStart(2, '0');
    return `${h}:${m}`;
  }
  const d = new Date(mtime);
  return `${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

function bucketLabel(mtime, b) {
  if (mtime == null) return 'Older';
  if (mtime >= b.today)        return 'Today';
  if (mtime >= b.yesterday)    return 'Yesterday';
  if (mtime >= b.earlierWeek)  return 'Earlier this week';
  if (mtime >= b.earlierMonth) return 'Earlier this month';
  return 'Older';
}

const LABEL_ORDER = [
  'Today', 'Yesterday', 'Earlier this week', 'Earlier this month', 'Older',
];

export function groupByRelativeDate(files, now) {
  if (!files || files.length === 0) return [];
  const today = startOfLocalDay(now);
  const b = {
    today,
    yesterday:    today - 1 * DAY,
    earlierWeek:  today - 7 * DAY,
    earlierMonth: today - 30 * DAY,
  };
  const byLabel = new Map();
  for (const f of files) {
    const label = bucketLabel(f.mtime, b);
    const enriched = {
      ...f,
      parentPath: parentPathOf(f.path),
      relativeAgo: formatRelativeTime(f.mtime, now),
    };
    if (!byLabel.has(label)) byLabel.set(label, []);
    byLabel.get(label).push(enriched);
  }
  return LABEL_ORDER
    .filter((label) => byLabel.has(label))
    .map((label) => ({ label, files: byLabel.get(label) }));
}
